import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ORDER_FEATURE } from '../root';
import { reducerProvider, reducerToken } from './reducers/index';

@NgModule({
  imports: [StoreModule.forFeature(ORDER_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class OrderStoreModule {}
